import React from 'react'
import styled, { useTheme } from 'styled-components/native'

import { AuthenticationButton } from 'features/auth/components/AuthenticationButton/AuthenticationButton'
import { StepperOrigin } from 'features/navigation/navigators/RootNavigator/types'
import { HeaderWithGreyContainer } from 'features/profile/components/Header/HeaderWithGreyContainer/HeaderWithGreyContainer'
import { analytics } from 'libs/analytics/provider'
import { InternalTouchableLink } from 'ui/components/touchableLink/InternalTouchableLink'
import { Button } from 'ui/designSystem/Button/Button'
import { Typo } from 'ui/theme'

const onBeforeNavigate = () => {
  void analytics.logProfilSignUp()
  void analytics.logSignUpClicked({ from: 'profile' })
}

export const LoggedOutHeader = () => {
  const { isDesktopViewport, designSystem } = useTheme()
  return (
    <HeaderWithGreyContainer title="Mon profil">
      <Typo.Body>
        Envie d’explorer des offres culturelles ou de débloquer ton crédit si tu as 17 ou 18
        ans&nbsp;?
      </Typo.Body>
      <Container>
        <InternalTouchableLink
          as={Button}
          fullWidth
          wording="Créer un compte"
          navigateTo={{ screen: 'SignupMethods', params: { from: StepperOrigin.PROFILE } }}
          onBeforeNavigate={onBeforeNavigate}
          fitContentWidth={isDesktopViewport}
        />
        {isDesktopViewport ? <VerticalSeparator /> : <Placeholder />}
        <AuthenticationButton
          type="login"
          linkColor={designSystem.color.text.brandSecondary}
          params={{ from: StepperOrigin.PROFILE }}
        />
      </Container>
    </HeaderWithGreyContainer>
  )
}

const Container = styled.View(({ theme }) => ({
  flexDirection: theme.isDesktopViewport ? 'row' : 'column',
  alignItems: theme.isDesktopViewport ? undefined : 'center',
  marginTop: theme.designSystem.size.spacing.xl,
}))

const VerticalSeparator = styled.View(({ theme }) => ({
  borderRightWidth: theme.designSystem.size.spacing.xxs,
  marginHorizontal: theme.designSystem.size.spacing.xl,
  borderRightColor: theme.designSystem.color.border.default,
}))

const Placeholder = styled.View(({ theme }) => ({ height: theme.designSystem.size.spacing.xl }))
